import type { FC } from "react";
import { motion } from "framer-motion";
import { AnalyticsListTypes } from "@lib/analytics/analyticsTypes";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ProductHitsWrapper } from "./ProductHitsWrapper";
import type { Document } from "@contentful/rich-text-types";
import dynamic from "next/dynamic";
import { useNormalizedInfiniteHits } from "@hooks/useNormalizedInfiniteHits";
import type { IPartStoryTile } from "@contentful-api/types/contentful";

const ProductListFooter = dynamic(
    () => import("@components/commerce/product/list/product-list-footer/ProductListFooter"),
    { ssr: false }
);

interface IProductListProps {
    authorizationInvitation: Document;
    widgetSize?: string;
    editorialWidgets?: IPartStoryTile[];
}

export const ProductList: FC<IProductListProps> = ({
    authorizationInvitation,
    widgetSize,
    editorialWidgets,
}) => {
    const { get: getMicrocopy } = useMicrocopy();
    const noResults = getMicrocopy("page", "PLP.summary.noResults");

    const { currentPageHits } = useNormalizedInfiniteHits();

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{
                opacity: 1,
            }}
            transition={{
                ease: "easeInOut",
                duration: 0.25,
                delay: 0.25,
            }}
        >
            <ProductHitsWrapper
                productListHits={currentPageHits}
                footerContent={<ProductListFooter />}
                noResultsContent={noResults}
                shouldSaveLastVisitedPath={true}
                productListName={AnalyticsListTypes.plp}
                authorizationInvitation={authorizationInvitation}
                widgetSize={widgetSize}
                editorialWidgets={editorialWidgets}
            />
        </motion.div>
    );
};
